export function getImageSizeFromUrl(url, callback)
{
    let image = new Image();
    image.src = url;
    image.onload = function() {
        callback(this.width, this.height);
    };
}